var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "trigger", staticClass: "variation-cross-selling-trigger" },
    [
      _vm.isVisible
        ? _c(
            "section",
            {
              staticClass: "row product-slider variation-cross-selling",
              class: { "is-dragging": _vm.isDragging },
            },
            [
              _c("h3", { staticClass: "h3" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$translate(
                        "biokinderDesign::Template.itemCrossSellingHeading"
                      )
                    ) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "product-slider-container position-relative",
                  class: { "is-loading": _vm.loading },
                },
                [
                  _vm.loading && _vm.renderedItems.length
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "variation-cross-selling-loading position-absolute w-100 h-100 d-flex align-items-center justify-content-center",
                        },
                        [_c("loading-animation")],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showSkeleton
                    ? _c(
                        "div",
                        { staticClass: "slider-skeleton row no-gutters" },
                        _vm._l(_vm.skeletonItemsCount, function (index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "product-slide col-12" },
                            [_vm._m(0, true)]
                          )
                        }),
                        0
                      )
                    : _vm.itemsVisible
                    ? _c(
                        "ul",
                        {
                          ref: "track",
                          staticClass:
                            "product-slider-slider crossSellingProduct variation-cross-selling__track",
                          on: {
                            scroll: _vm.updateScrollControls,
                            "!click": function ($event) {
                              return _vm.preventClickAfterDrag.apply(
                                null,
                                arguments
                              )
                            },
                            pointerdown: _vm.startDrag,
                            pointermove: _vm.drag,
                            pointerup: _vm.stopDrag,
                            pointercancel: _vm.stopDrag,
                            pointerleave: _vm.stopDrag,
                          },
                        },
                        _vm._l(_vm.renderedItems, function (item) {
                          return _c(
                            "li",
                            {
                              key: item.variation.id,
                              staticClass:
                                "product-slide col-12 variation-cross-selling__item",
                            },
                            [
                              _c("category-item", {
                                attrs: {
                                  "image-url-accessor": "urlSecondPreview",
                                  "item-data": item,
                                  "decimal-count": _vm.decimalCount,
                                  "disable-carousel": true,
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.renderedItems.length > 1
                    ? _c(
                        "div",
                        { staticClass: "variation-cross-selling__controls" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "variation-cross-selling__control",
                              attrs: {
                                type: "button",
                                "aria-label": "Vorherige Artikel",
                                disabled: !_vm.canScrollPrevious,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.scrollByPage(-1)
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    "aria-hidden": "true",
                                    viewBox: "0 0 24 24",
                                  },
                                },
                                [_c("path", { attrs: { d: "m15 18-6-6 6-6" } })]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "variation-cross-selling__control",
                              attrs: {
                                type: "button",
                                "aria-label": "Nächste Artikel",
                                disabled: !_vm.canScrollNext,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.scrollByPage(1)
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    "aria-hidden": "true",
                                    viewBox: "0 0 24 24",
                                  },
                                },
                                [_c("path", { attrs: { d: "m9 18 6-6-6-6" } })]
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "variation-cross-selling-skeleton-card" }, [
      _c("div", { staticClass: "skeleton-image" }, [
        _c("span", { staticClass: "skeleton-basket" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "skeleton-text" }),
      _vm._v(" "),
      _c("div", { staticClass: "skeleton-text" }),
      _vm._v(" "),
      _c("div", { staticClass: "skeleton-price" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }